const NotificationIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 53 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.61041 19.2632C7.61041 8.90786 16.0051 0.513184 26.3604 0.513184C36.7157 0.513184 45.1104 8.90786 45.1104 19.2632V30.5132L52.6104 38.0132V45.5132H0.110413V38.0132L7.61041 30.5132V19.2632Z"
        fill="black"
      />
      <path
        d="M26.3604 60.5132C21.4621 60.5132 17.2949 57.3827 15.7505 53.0132H36.9703C35.426 57.3827 31.2587 60.5132 26.3604 60.5132Z"
        fill="black"
      />
    </svg>
  );
};

export default NotificationIcon;
